import React from 'react';
import styles from './PatientHeader.module.scss';

interface Props {
	patientAge: number;
	patientName: string;
	patientPhoto: string;
}

const PatientHeader: React.FC<Props> = ({
	patientAge,
	patientName,
	patientPhoto,
}) => {
	return (
		<div className={styles.wrapper}>
			<img src={patientPhoto} alt={'avatar'} />
			<div className={styles.content}>
				<div className={styles.title}>{patientName}</div>
				<div>{patientAge}</div>
			</div>
		</div>
	);
};

export default PatientHeader;
